import { InfoCircleFill } from 'react-bootstrap-icons';
import { useParams } from 'react-router-dom';

import { Typography } from 'antd';

import Alert from '@/components/shared/Alert';
import { formatDate } from '@/helpers/formatDate';
import { enStatus } from '@/interfaces/course';
import { coursesApi } from '@/services/course';
import styled, { StyledProp } from '@/styled';

const Expired = ({ className }: StyledProp) => {
  const { hash } = useParams<{ hash: string }>();
  const { data: course } = coursesApi.endpoints.getCourse.useQueryState(hash, { skip: !hash });

  if (course?.status !== enStatus.EXPIRED) {
    return null;
  }

  const messageDate = course?.expire_at ? ` em ${formatDate(course?.expire_at)}` : '';

  return (
    <Alert
      className={className}
      icon={<InfoCircleFill size={20} />}
      type='error'
      message='Curso expirado'
      description={
        <Typography.Text>
          Esse curso expirou{messageDate}. Para mais informações, acesse a aba
          <Typography.Text strong> Falar com o produtor</Typography.Text> na área do curso.
        </Typography.Text>
      }
    />
  );
};

export default styled(Expired)``;
